import type { UserMetadataI } from './authUtils';
import http from './httpUtils';

type UserServiceRequest = {
  query: string;
  variables?: Record<string, unknown>;
};

type UserServiceResponse = {
  errors?: Array<{ message?: string }>;
};

const postUserServiceRequest = http.post<
  UserServiceResponse,
  UserServiceRequest
>('', 'userService');

export const updateUserMetadata = async (
  email: string,
  metaData: UserMetadataI
) => {
  const response = await postUserServiceRequest({
    query: `mutation UpdateUser($user: UserInput, $changed: ChangedUser) {
        updateUser(user: $user, changed: $changed) {
          email
        }
      }`,
    variables: {
      user: { email },
      changed: {
        metaData,
      },
    },
  });

  if (response.errors?.length) {
    throw new Error(
      response.errors[0]?.message || 'Failed to update user metadata.'
    );
  }
};
